import { ConfigProvider } from 'antd';
import Root from 'components/root/Root';
import theme from 'hyarchis-global/styles/themes/default';
import React, { useEffect, useState } from 'react';
import { ThemeProvider } from 'styled-components';
import WebFontLoader from 'webfontloader';
import { Provider } from 'react-redux';
import { Store } from 'redux';
import { ApplicationState } from 'store/types';
import { createBrowserHistory, History } from 'history';
import { configureStore } from 'store';
import { DEPLOYMENT_PATH } from 'app-constants';
import setupHyarchisGlobalComponents from '3rd-parties/hyarchis-global-components';
import setupAxiosMiddlewares from '3rd-parties/axios';

setupHyarchisGlobalComponents();
const Main = () => {
  const [history, setHistory] = useState<History | undefined>();
  const [store, setStore] = useState<Store<ApplicationState> | undefined>();

  useEffect(() => {
    WebFontLoader.load({ custom: { families: ['Muli'], urls: ['./fonts/fonts.css'] } });

    const createdHistory = createBrowserHistory({ basename: DEPLOYMENT_PATH });
    const storeInstance = configureStore(createdHistory);

    setStore(storeInstance);
    setHistory(createdHistory);
  }, []);

  useEffect(() => {
    if (store) {
      setupAxiosMiddlewares();
    }
  }, [store]);

  if (!store || !history) {
    return null;
  }

  return (
    <ThemeProvider theme={theme(false)}>
      <ConfigProvider>
        <Provider store={store}>
          <Root />
        </Provider>
      </ConfigProvider>
    </ThemeProvider>
  );
};

export default Main;
